export default __webpack_public_path__ + "static/media/09n.1ade2004.jpg";